import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { BelfiusButton, BelfiusTextInput } from '../custom';
import { fetchCaseForMobile, setSearchCase } from '../../store/case';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import { setMobileView } from '../../store/shared/actions';
import styles from './mobileSearch.module.css';

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  readonly fetchCaseForMobile: typeof fetchCaseForMobile;
  readonly setMobileView: typeof setMobileView;
  readonly setSearchCase: typeof setSearchCase;
}

interface PropsFromState {
  readonly isUIDisabled: boolean;
  readonly caseCode: string;
  readonly showCaseNotFoundMessage: boolean;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class MobileSearch extends React.Component<AllProps> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      caseCode: ''
    };
  }

  public render() {
    const strings = getI18n();

    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logoContainer}>
            <div className={styles.logo}>
              <a href='http://www.zamia.be' target='_blank' rel='noreferrer'><img alt="" className={styles.logo} src={require('../../assets/images/prodatex_home.png')} /></a>
            </div>
          </div>
          <div id='loader' className={styles.searchcontainer}>
            <div className={styles.logo}>
              <img alt="" hidden={!this.props.isUIDisabled} src={require('../../assets/images/spinnerLoaderGray.gif')} />
            </div>
          </div>
          <div className={styles.formContainer}>
            <BelfiusTextInput
              className={styles.caseCode}
              value={this.props.caseCode}
              placeholder={strings.get('home.search.caseCode')}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                this.props.setSearchCase(event.target.value )} />
            <BelfiusButton
              className={styles.searchButton}
              onClick={() => this.props.fetchCaseForMobile(this.props.caseCode)}
              title={strings.get('home.search.button')} />
              <span hidden={!this.props.showCaseNotFoundMessage} className={styles.caseNotFoundMessage}>{ strings.get('home.search.caseNotFoundMessage')}</ span>
          </div>
          <div className={styles.switchView}
            onClick={() => this.props.setMobileView(false)}>{ strings.get('home.switchToFullView')}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ shared, caseState }: ApplicationState): PropsFromState => ({
  isUIDisabled: shared.isUIDisabled,
  caseCode: caseState.searchCase,
  showCaseNotFoundMessage: caseState.showCaseNotFoundMessage
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCaseForMobile: (caseCode: string) => dispatch(fetchCaseForMobile(caseCode)),
  setSearchCase: (caseCode: string) => dispatch(setSearchCase(caseCode)),
  setMobileView: (mobileViewSelected: boolean) => dispatch(setMobileView(mobileViewSelected))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileSearch);
